import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-up",
  "use": "icon-up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-up\"><path fill-rule=\"evenodd\" d=\"M20.964 16.702L12.614 5.31a.76.76 0 00-1.225 0L3.036 16.702a.186.186 0 00-.015.196.19.19 0 00.17.102h1.775c.121 0 .235-.059.306-.155L12 7.667l6.729 9.178a.381.381 0 00.305.155h1.776a.188.188 0 00.154-.298z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol